/** @deprecated Use the type instead */
export const FeatureName = {
  ACCESS_MANAGER: 'ACCESS_MANAGER',

  MANAGE_ALL: 'MANAGE_ALL',
  MANAGE_WORKBOOK_SNAPSHOTS: 'MANAGE_WORKBOOK_SNAPSHOTS',

  LIST_GROUP: 'LIST_GROUP',
  EDIT_GROUP: 'EDIT_GROUP',
  EDIT_ROLE: 'EDIT_ROLE',
  LIST_USER: 'LIST_USER',

  ANALYTICS_AGGREGATION_WITH_STD: 'ANALYTICS_AGGREGATION_WITH_STD',
  CLIENT_SIDE_RENDERED_LEGEND: 'CLIENT_SIDE_RENDERED_LEGEND',
  CSV_EXPORT: 'CSV_EXPORT',

  EXCEL_EXPORT: 'EXCEL_EXPORT',

  EXTENDED_PERMALINK_CREATION: 'EXTENDED_PERMALINK_CREATION',

  CREATE_REPOSITORY: 'CREATE_REPOSITORY',
  EXPORT_DATABASE_REPOSITORY: 'EXPORT_DATABASE_REPOSITORY',

  GEOCODING: 'GEOCODING',
  GEOCODING_OPERATION_STRUCTURED: 'GEOCODING_OPERATION_STRUCTURED',
  GEOCODING_OPERATION_UNSTRUCTURED: 'GEOCODING_OPERATION_UNSTRUCTURED',

  GEOCODER_IP_OPERATION: 'GEOCODER_IP_OPERATION',

  IMPORT_DATABASE_REPOSITORY: 'IMPORT_DATABASE_REPOSITORY',

  JOB_MANAGEMENT: 'JOB_MANAGEMENT',
  JOB_SUBSCRIPTION: 'JOB_SUBSCRIPTION',

  KML_EXPORT: 'KML_EXPORT',

  MODIFY_MAP_ANIMATION_CONFIGURATION: 'MODIFY_MAP_ANIMATION_CONFIGURATION',
  PLAY_MAP_ANIMATION: 'PLAY_MAP_ANIMATION',
  REPOSITORY_RELOAD: 'REPOSITORY_RELOAD',
  ROUTING: 'ROUTING',
  SIMPLE_ROUTING_PRINTOUT_CLASSIC: 'SIMPLE_ROUTING_PRINTOUT_CLASSIC',
  SHAPEFILE_EXPORT: 'SHAPEFILE_EXPORT',

  TIMELINE_3D: 'TIMELINE_3D',
  TIMELINE_IMPORT: 'TIMELINE_IMPORT',
  TIMELINE_IMPORT_CLASSIC: 'TIMELINE_IMPORT_CLASSIC',

  WEBAPP_INTEGRATION: 'WEBAPP_INTEGRATION',

  WORKBOOK: 'WORKBOOK',
  WORKBOOK_CREATION: 'WORKBOOK_CREATION',
  WORKBOOK_IMPORT: 'WORKBOOK_IMPORT',
  WORKBOOK_SELF_SERVICE: 'WORKBOOK_SELF_SERVICE',
  WORKBOOK_SNAPSHOTS_USE: 'WORKBOOK_SNAPSHOTS_USE',
  WORKBOOK_EDIT_SPATIAL_CONDITION: 'WORKBOOK_EDIT_SPATIAL_CONDITION',
  SELF_SERVICE_IMPORT: 'SELF_SERVICE_IMPORT',
  MARK_OBJECTTYPE_AS_TEMPLATE: 'MARK_OBJECTTYPE_AS_TEMPLATE',
  CREATE_OBJECTTYPE_BASED_ON_TEMPLATE: 'CREATE_OBJECTTYPE_BASED_ON_TEMPLATE',
  ACQUIRE_OBJECTTYPE_DATA: 'ACQUIRE_OBJECTTYPE_DATA',
  IMPORT_PRESETS: 'IMPORT_PRESETS',

  EDIT_REPORT: 'EDIT_REPORT',

  SUBSCRIBE_TO_WORKBOOK: 'SUBSCRIBE_TO_WORKBOOK',

  // TODO (palys), this it a temporary solution, remove it soon! CADENZA-25837
  CREATE_ELASTIC_SEARCH_TEST_OBJECTTYPES: 'CREATE_ELASTIC_SEARCH_TEST_OBJECTTYPES',
  WRITABLE_DATABASE_REPOSITORY: 'WRITABLE_DATABASE_REPOSITORY',
  WRITABLE_DATABASE_REPOSITORY_WITH_CMDB: 'WRITABLE_DATABASE_REPOSITORY_WITH_CMDB',

  CREATE_SKETCH_LAYER: 'CREATE_SKETCH_LAYER',
  EDIT_SKETCH_LAYER: 'EDIT_SKETCH_LAYER',
  CUSTOM_SKETCH_EDITORS: 'CUSTOM_SKETCH_EDITORS',

  EDIT_ATTRIBUTE_FUNCTION: 'EDIT_ATTRIBUTE_FUNCTION'
} as const;

/** @see net/disy/cadenza/web/core/feature/FeatureName.java */
export type FeatureName = keyof typeof FeatureName;

const THEME_FEATURE_NAMES = [
  'custom-map-featureInfo',
  'custom-map-measuring',
  'nav-tree-highlight-last-clicked-node',
  'classic-map-add-layer-wfs',
  'classic-map-add-layer-wms',
  'classic-map-add-layer-shapefile',
  'classic-map-add-layer-kml',
  'classic-map-add-layer-self-service',
  'classic-map-add-layer-timeline',
  'classic-map-add-layer-grid-square'
] as const;

export type ThemeFeatureName = typeof THEME_FEATURE_NAMES[number];

const UI_FEATURE_NAMES = [ 'workbook-partial-view' ] as const;

export type UiFeatureName = typeof UI_FEATURE_NAMES[number];

/**
 * Checks the availability of a Cadenza feature for the current user.
 *
 * @param featureName - The name of the feature to check
 * @return Whether the feature is available.
 * @see net/disy/cadenza/web/core/feature/IWebFeature.java
 */
export function isFeatureAvailable (featureName: FeatureName): boolean;
/**
 * Checks the availability of a Cadenza theme feature for the current user.
 *
 * @param featureName - The name of the feature to check
 * @return Whether the feature is available.
 * @see net/disy/cadenza/web/theme/theme.js
 */
export function isFeatureAvailable (featureName: ThemeFeatureName): boolean | undefined;

/**
 * Checks the availability of a Cadenza UI feature.
 *
 * @param featureName - The name of the feature to check
 * @return Whether the feature is available.
 */
export function isFeatureAvailable (featureName: UiFeatureName): boolean;
export function isFeatureAvailable (featureName: FeatureName | ThemeFeatureName | UiFeatureName) {
  if (isThemeFeature(featureName)) {
    return window.Disy.theme.features?.[featureName];
  }
  if (isUiFeature(featureName)) {
    return window.Disy.uiFeatures?.includes(featureName) ?? false;
  }
  return window.Disy.availableFeatures?.includes(featureName) ?? false;
}

function isThemeFeature (featureName: FeatureName | ThemeFeatureName | UiFeatureName): featureName is ThemeFeatureName {
  return THEME_FEATURE_NAMES.includes(featureName as never);
}

function isUiFeature (featureName: FeatureName | ThemeFeatureName | UiFeatureName): featureName is UiFeatureName {
  return UI_FEATURE_NAMES.includes(featureName as never);
}
